
import * as handlebars_family from "../handlebars_family.js";

const TPL = handlebars_family.addTemplate("modal/media_in_modal",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isImage") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":796}}})) != null ? stack1 : "")
    + " ";
},"2":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <p class=\"cover\" style=\"background-image:url('"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"pictureUrl") : depth0), depth0))
    + "w=1024&h=512&s=r');background-color:"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"color") : depth0), depth0))
    + "\" data-fw-meta-id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\" data-media-viewer-group=\"modal-gallery\" data-fw-onclick=\"fileview\"></p> ";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexcol class=\"border-pane filer-file\" data-fw-meta-id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\" draggable=\"true\" style=\"padding:0;gap:0;height:170px;overflow: hidden;\" data-fw-onclick=\"fileview\" data-media-viewer-group=\"modal-gallery\"><flexcenter class=\"flexauto\" style=\"background-color:"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"color") : depth0), depth0))
    + "15;border-bottom:var(--border)\"> "
    + ((stack1 = (lookupProperty(helpers,"iconsimple")||(depth0 && lookupProperty(depth0,"iconsimple"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"font-size:40px",{"name":"iconsimple","hash":{},"data":data,"loc":{"start":{"line":1,"column":563},"end":{"line":1,"column":596}}})) != null ? stack1 : "")
    + " </flexcenter><flexrow style=\"padding:var(--space)\"><flexauto><line>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "</line><line class=\"sub4\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"size") : depth0), depth0))
    + " "
    + container.escapeExpression(lookupProperty(helpers,"deltatime").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"filerModifDate") : depth0),"fullDate",{"name":"deltatime","hash":{},"data":data,"loc":{"start":{"line":1,"column":711},"end":{"line":1,"column":750}}}))
    + "</line></flexauto></flexrow></flexcol> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"medias") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":806}}})) != null ? stack1 : "")
    + " ";
},"useData":true});
export default TPL;